/* eslint-disable no-undef */
import Vue from "vue"
import ApiUrl from "../apiurl"

export default {
	namespaced: true,
	state: {},
	getters: {},
	mutations: {},
	actions: {
		async getCompanies({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.manage.companies, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},

		async getmanageUpdate({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.manage.manageUpdate, null, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},

		async getmanageManageAdd({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.manage.manageAdd, null, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},

		async getmanageManageDelete({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.delete(ApiUrl.manage.manageDelete, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		//专利信息
		// async getmanageManagePatent({ commit }, { data, handle }) {
		// 	try {
		// 		commit("startLoading", null, {
		// 			root: true
		// 		})
		// 		const rsp = await axios.get(ApiUrl.manage.managePatent, data)
		// 		handle && handle(rsp.data)
		// 	} catch (e) {
		// 		console.error(e)
		// 	} finally {
		// 		commit("stopLoading", null, { root: true })
		// 	}
		// },

		async getmanageManageSearch({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.manage.manageSearch, null, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
		//专利的信息
		async getmanaGemanagePatent({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.post(ApiUrl.manage.managePatent, null, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		},
        async getManageEnterprise({commit}, {data,handle}){
            try {
                commit('startLoading', null, {
                    root: true
                });
                const rsp = await axios.get(ApiUrl.manage.manageEnterprise, data);
                handle && handle(rsp.data);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true});
            }
        }, 

		async getmanageCompanyindex({ commit }, { data, handle }) {
			try {
				commit("startLoading", null, {
					root: true
				})
				const rsp = await axios.get(ApiUrl.manage.manageCompanyindex, data)
				handle && handle(rsp.data)
			} catch (e) {
				console.error(e)
			} finally {
				commit("stopLoading", null, { root: true })
			}
		}
	}
}
